import { useAuth } from "@/hooks/use-auth";
import { Button } from "@/components/ui/button";
import {
    useCheckVerification,
    useSendVerification,
} from "../../hooks/use-verify-email";

export const CheckEmail = () => {
    const { user } = useAuth();

    const userEmail = user?.email || "";

    const checkVerificationMutation = useCheckVerification();
    const sendVerificationMutation = useSendVerification();

    return (
        <div className="w-full space-y-3 text-center">
            <h1 className="mb-3 text-3xl font-medium">Verify your email</h1>
            <p className="mb-3">
                We have sent a verification email to{" "}
                <strong>{userEmail}</strong>.
            </p>
            <p>
                Please click on the link to complete the verification process.
                If you don't see it, you may need to{" "}
                <strong>check your spam</strong> folder.
            </p>
            <Button
                type="button"
                variant="primary"
                onClick={() => {
                    sendVerificationMutation.reset();
                    checkVerificationMutation.mutate();
                }}
                className="mx-auto mt-4"
                disabled={checkVerificationMutation.isPending}
            >
                {checkVerificationMutation.isPending
                    ? "Checking..."
                    : "I've verified my email"}
            </Button>
            <button
                type="button"
                className="cursor-pointer text-sm hover:underline"
                onClick={() => {
                    checkVerificationMutation.reset();
                    sendVerificationMutation.mutate();
                }}
                disabled={sendVerificationMutation.isPending}
            >
                <strong>
                    {sendVerificationMutation.isPending
                        ? "Sending..."
                        : "Resend verification email"}
                </strong>
            </button>
        </div>
    );
};
